import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { bankAccountAPI } from '../../utils/api';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Building } from 'lucide-react';

const BankAccounts = () => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAccounts();
  }, []);

  const fetchAccounts = async () => {
    try {
      const response = await bankAccountAPI.getAll();
      setAccounts(response.data);
    } catch (error) {
      toast.error('Failed to load bank accounts');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="flex items-center justify-center min-h-[60vh]"><div className="loading-spinner"></div></div>;

  return (
    <div className="space-y-8 animate-fadeIn">
      <div>
        <h1 className="text-4xl font-bold text-black mb-2">Bank Accounts</h1>
        <p className="text-gray-600">Manage your linked bank accounts</p>
      </div>

      {accounts.length === 0 ? (
        <Card className="p-6">
          <div className="flex items-center justify-center py-12">
            <div className="text-center">
              <Building className="w-12 h-12 text-gray-600 mx-auto mb-4" />
              <p className="text-gray-500">No bank accounts linked</p>
              <Button className="mt-4 text-white hover:opacity-90" style={{ background: '#062136' }}>Add Bank Account</Button>
            </div>
          </div>
        </Card>
      ) : (
        <div className="grid gap-4">
          {accounts.map(account => (
            <Card key={account.id} className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-black">{account.bank_name}</p>
                  <p className="text-sm text-gray-600">****{account.account_number.slice(-4)}</p>
                </div>
                <span className="text-xs text-green-600">Verified</span>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default BankAccounts;